import { logger } from "./logger";

interface ErrorContext {
  name?: string;
  route?: string;
  props?: Record<string, any>;
  userId?: string;
  workspaceId?: string;
}

export const captureError = (error: Error, context: ErrorContext = {}) => {
  const stack = error.stack;
  const timestamp = new Date().toISOString();
  const currentRoute = window.location.pathname;

  const errorData = {
    message: error.message,
    stack,
    timestamp,
    route: context.route || currentRoute,
    component: context.name,
    props: context.props,
    userId: context.userId,
    workspaceId: context.workspaceId,
    userAgent: navigator.userAgent,
  };

  // Log to console for development
  logger.error("Error captured:", errorData);

  // Here we would typically send to a real observability service like Sentry, Loggly, or a custom Supabase Edge Function
  // For now, we store in a local ring-buffer for telemetry/debugging if needed
  try {
    const logs = JSON.parse(localStorage.getItem("error_telemetry") || "[]");
    logs.push(errorData);
    // Keep only last 50 errors
    if (logs.length > 50) logs.shift();
    localStorage.setItem("error_telemetry", JSON.stringify(logs));
  } catch (e) {
    // Silent fail for storage
  }
};
